var map = {
	".": 104,
	"./": 104,
	"./ch/404.ch": 670,
	"./ch/404.ch.json": 670,
	"./ch/home.ch": 671,
	"./ch/home.ch.json": 671,
	"./ch/page-search.ch": 672,
	"./ch/page-search.ch.json": 672,
	"./ch/translation.ch": 673,
	"./ch/translation.ch.json": 673,
	"./en/404.en": 674,
	"./en/404.en.json": 674,
	"./en/home.en": 675,
	"./en/home.en.json": 675,
	"./en/page-search.en": 676,
	"./en/page-search.en.json": 676,
	"./en/translation.en": 677,
	"./en/translation.en.json": 677,
	"./id/404.id": 678,
	"./id/404.id.json": 678,
	"./id/home.id": 679,
	"./id/home.id.json": 679,
	"./id/page-search.id": 680,
	"./id/page-search.id.json": 680,
	"./id/translation.id": 681,
	"./id/translation.id.json": 681,
	"./index": 104,
	"./index.js": 104,
	"./th/404.th": 682,
	"./th/404.th.json": 682,
	"./th/home.th": 683,
	"./th/home.th.json": 683,
	"./th/page-search.th": 684,
	"./th/page-search.th.json": 684,
	"./th/translation.th": 685,
	"./th/translation.th.json": 685,
	"./vi/404.vi": 686,
	"./vi/404.vi.json": 686,
	"./vi/home.vi": 687,
	"./vi/home.vi.json": 687,
	"./vi/page-search.vi": 688,
	"./vi/page-search.vi.json": 688,
	"./vi/translation.vi": 689,
	"./vi/translation.vi.json": 689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;